import contact from "./Contact";
import Country from "./Country";
import Currency from "./Currency";
import ShipmentCategory from "./ShipmentCategory";
import WarehouseMove from "./WarehouseMove";

const Shipment = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    // Associations
    category = false,
    consignee = false,
    consignor = false,
    currency = false,
    delCountry = false,
    oriContact = false,
    oriCountry = false,
    shipper = false,
    warehouseMoves = false,
    // Scalar fields
    agent = includeDefaults,
    bondRef = includeDefaults,
    bondReleaseRef = includeDefaults,
    cancel = includeDefaults,
    categoryId = includeDefaults,
    cds = includeDefaults,
    condition = includeDefaults,
    consigneeId = includeDefaults,
    consignorId = includeDefaults,
    currencyId = includeDefaults,
    customsDate = includeDefaults,
    customsCode = includeDefaults,
    customsCodeMatch = includeDefaults,
    customsCheck = includeDefaults,
    customsCheckDate = includeDefaults,
    customsCheckUser = includeDefaults,
    customsDeclaration = includeDefaults,
    customsRef = includeDefaults,
    customsRequest = includeDefaults,
    customsRequestDate = includeDefaults,
    customsRequestUser = includeDefaults,
    customsReceived = includeDefaults,
    customsReceivedDate = includeDefaults,
    customsReceivedUser = includeDefaults,
    date = includeDefaults,
    declarant = includeDefaults,
    delAddress = includeDefaults,
    delAddress2 = includeDefaults,
    delAddress3 = includeDefaults,
    delCompany = includeDefaults,
    delContactId = includeDefaults,
    delCountryId = includeDefaults,
    delCounty = includeDefaults,
    delivered = includeDefaults,
    delName = includeDefaults,
    delPostcode = includeDefaults,
    delTown = includeDefaults,
    destination = includeDefaults,
    dispatched = includeDefaults,
    eori = includeDefaults,
    examined = includeDefaults,
    guaranteeAccountId = includeDefaults,
    incoTerm = includeDefaults,
    insurance = includeDefaults,
    instructions = includeDefaults,
    jobId = includeDefaults,
    oriAddress = includeDefaults,
    oriAddress2 = includeDefaults,
    oriAddress3 = includeDefaults,
    oriCompany = includeDefaults,
    oriContactId = includeDefaults,
    oriCountryId = includeDefaults,
    oriCounty = includeDefaults,
    oriName = includeDefaults,
    oriPostcode = includeDefaults,
    oriTown = includeDefaults,
    shipmentDescriptions = includeDefaults,
    shipperId = includeDefaults,
    shipping = includeDefaults,
    shippingRef = includeDefaults,
    time = includeDefaults,
    itemCount = includeDefaults,
    totalValue = includeDefaults,
    unconfirmedItemCount = includeDefaults,
    updatedAt = includeDefaults,
  } = propsObj;

  return `
  id
  ${agent ? "agent" : ""}
  ${bondRef ? "bondRef" : ""}
  ${bondReleaseRef ? "bondReleaseRef" : ""}
  ${cancel ? "cancel" : ""}
  ${
    category
      ? `category {
      ${ShipmentCategory}
    }`
      : ""
  }
  ${categoryId ? "categoryId" : ""}
  ${cds ? "cds" : ""}
  ${condition ? "condition" : ""}
  ${
    consignee
      ? `consignee {
      ${contact(consignee)}
    }`
      : ""
  }
  ${consigneeId ? "consigneeId" : ""}
  ${
    consignor
      ? `consignor {
      ${contact(consignor)}
    }`
      : ""
  }
  ${consignorId ? "consignorId" : ""}
  ${
    currency
      ? `currency {
      ${Currency}
    }`
      : ""
  }
  ${currencyId ? "currencyId" : ""}
  ${customsDate ? "customsDate" : ""}
  ${customsCode ? "customsCode" : ""}
  ${customsCodeMatch ? "customsCodeMatch" : ""}
  ${customsCheck ? "customsCheck" : ""}
  ${customsCheckDate ? "customsCheckDate" : ""}
  ${customsCheckUser ? "customsCheckUser" : ""}
  ${customsDeclaration ? "customsDeclaration" : ""}
  ${customsRef ? "customsRef" : ""}
  ${customsRequest ? "customsRequest" : ""}
  ${customsRequestDate ? "customsRequestDate" : ""}
  ${customsRequestUser ? "customsRequestUser" : ""}
  ${customsReceived ? "customsReceived" : ""}
  ${customsReceivedDate ? "customsReceivedDate" : ""}
  ${customsReceivedUser ? "customsReceivedUser" : ""}
  ${date ? "date" : ""}
  ${declarant ? "declarant" : ""}
  ${delAddress ? "delAddress" : ""}
  ${delAddress2 ? "delAddress2" : ""}
  ${delAddress3 ? "delAddress3" : ""}
  ${delCompany ? "delCompany" : ""}
  ${delContactId ? "delContactId" : ""}
  ${
    delCountry
      ? `delCountry {
      ${Country}
    }`
      : ""
  }
  ${delCountryId ? "delCountryId" : ""}
  ${delCounty ? "delCounty" : ""}
  ${delivered ? "delivered" : ""}
  ${delName ? "delName" : ""}
  ${delPostcode ? "delPostcode" : ""}
  ${delTown ? "delTown" : ""}
  ${destination ? "destination" : ""}
  ${dispatched ? "dispatched" : ""}
  ${eori ? "eori" : ""}
  ${examined ? "examined" : ""}
  ${guaranteeAccountId ? "guaranteeAccountId" : ""}
  ${incoTerm ? "incoTerm" : ""}
  ${insurance ? "insurance" : ""}
  ${instructions ? "instructions" : ""}
  ${jobId ? "jobId" : ""}
  ${oriAddress ? "oriAddress" : ""}
  ${oriAddress2 ? "oriAddress2" : ""}
  ${oriAddress3 ? "oriAddress3" : ""}
  ${oriCompany ? "oriCompany" : ""}
  ${
    oriContact
      ? `oriContact {
      ${contact(oriContact)}
    }`
      : ""
  }
  ${oriContactId ? "oriContactId" : ""}
  ${
    oriCountry
      ? `oriCountry {
      ${Country}
    }`
      : ""
  }
  ${oriCountryId ? "oriCountryId" : ""}
  ${oriCounty ? "oriCounty" : ""}
  ${oriName ? "oriName" : ""}
  ${oriPostcode ? "oriPostcode" : ""}
  ${oriTown ? "oriTown" : ""}
  ${shipmentDescriptions ? "shipmentDescriptions" : ""}
  ${
    shipper
      ? `shipper {
      ${contact(shipper)}
    }`
      : ""
  }
  ${shipperId ? "shipperId" : ""}
  ${shipping ? "shipping" : ""}
  ${shippingRef ? "shippingRef" : ""}
  ${time ? "time" : ""}
  ${itemCount ? "itemCount" : ""}
  ${totalValue ? "totalValue" : ""}
  ${unconfirmedItemCount ? "unconfirmedItemCount" : ""}
  ${updatedAt ? "updatedAt" : ""}
  ${
    warehouseMoves
      ? `warehouseMoves {
      ${WarehouseMove(warehouseMoves)}
    }`
      : ""
  }
`;
};

export default Shipment;
